<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <h4>
          List of Enquiries
          <FilterName :currentFilter="savedFilter" />
        </h4>
        <Toolbar class="p-mb-4">
          <template slot="left">
            <span class="p-input-icon-left mb-2">
              <div class="p-inputgroup">
                <Button
                  icon="pi pi-fw pi-refresh"
                  class="p-mr-1"
                  @click="setupComponentData(1)"
                />
                <Button
                  icon="pi pi-fw pi-cog"
                  class="p-mr-1"
                  @click="openColumnsSelection()"
                />
                <InputText
                  v-model="searchText"
                  placeholder="Global Search"
                  @input="updateSearch"
                />
                <Button
                  icon="pi pi-times p-pr-1"
                  class="p-mr-1"
                  @click="closeSearch"
                />
                <div
                  :class="getClassForQuickFiltersDiv()"
                  :key="quickFiltersDivKey"
                >
                  <Button
                    style="width: 50px; top: 50%; transform: translate(0%, -50%);"
                    @click="
                      quickFilterDialog = true;
                      quickFilterDialogKey++;
                    "
                    icon="pi pi-filter"
                    :class="
                      'p-button-rounded ' + getClassForQuickFiltersButon()
                    "
                    :badge="getBadgeForQuickFilters().toString()"
                  />
                  <Button
                    v-if="isEmpty()"
                    @click="clearQuickFilter()"
                    icon="pi pi-times"
                    :class="
                      'p-button-rounded ' + getClassForQuickFiltersButon()
                    "
                  />
                </div>
              </div>
            </span>
          </template>
          <template slot="right">
            <div>
              <Button
                style="height: 36px;"
                @click="makeFavorite()"
                :icon="favorite ? 'pi pi-star' : 'pi pi-star-o'"
                class="p-mr-1 p-button-text p-button-danger"
                :disabled="
                  !(savedFilter && savedFilter.id) || favoriteRequesting
                "
              />
              <Dropdown
                v-model="savedFilter"
                :options="savedFilters"
                optionLabel="filterName"
                dataKey="id"
                placeholder="Select Saved Filter"
                :showClear="true"
                style="width: 200px;"
              >
                <template #option="slotProps">
                  {{ slotProps.option.filterName }}
                </template>
              </Dropdown>
              <Button
                style="height: 36px;"
                @click="editSelectedFilter()"
                icon="pi pi-pencil"
                class="p-mx-1"
                :disabled="!(savedFilter && savedFilter.id)"
              />
              <Button
                style="height: 36px;"
                @click="deleteSavedFilterWarning = true"
                icon="pi pi-trash"
                class="p-mr-1 p-button-danger"
                :disabled="!(savedFilter && savedFilter.id)"
              />
              <Button
                label="New filter"
                icon="pi pi-plus"
                class="p-button-success p-mt-1"
                @click="newFilter()"
              />
              <Button
                label="New Enquiry"
                icon="pi pi-plus"
                class="p-button-success p-mr-2 ml-2 mt-1"
                style="margin-right: 1em"
                @click="openNew"
              />
            </div>
          </template>
        </Toolbar>
      </div>
    </div>

    <Dialog
      :key="quickFilterDialogKey"
      :visible.sync="quickFilterDialog"
      :style="{ width: '500px', overflowY: 'auto' }"
      header="Quick Filters"
      :modal="true"
      class="p-fluid"
    >
      <div v-for="(element, index) in dbViewFieldsForQuickFilters" :key="index">
        <div v-if="element.quickFilter === true" class="p-formgrid p-grid">
          <div class="p-field p-col p-d-flex">
            <label class="p-as-center" :for="element.fieldName">
              {{ element.fieldName }}
            </label>
          </div>
          <div class="p-field p-col">
            <div v-if="isQuickFilterable(index)">
              <div v-if="getFieldType(index) === 'Date'" style="width: 250px;">
                <Dropdown
                  :showClear="true"
                  v-model="quickFiltersSelection[index]"
                  :options="getOptions(index)"
                  optionLabel="dateModifierName"
                  dataKey="id"
                  placeholder="Select from the dropdown"
                  style="width: 100%"
                />
                <div class="pt-1">
                  <InputMask
                    v-if="showDateRanges(index)"
                    mask="99/99/9999"
                    v-model="datesFrom[index]"
                    slotChar="dd/mm/yyyy"
                    placeholder="Date from"
                    style="width: 49%;"
                  />
                  <InputMask
                    v-if="showDateRanges(index)"
                    mask="99/99/9999"
                    v-model="datesTo[index]"
                    slotChar="dd/mm/yyyy"
                    placeholder="Date to"
                    style="width: 49%; float: right;"
                  />
                </div>
              </div>
              <div
                v-else-if="getFieldType(index) === 'Currency'"
                style="width: 250px;"
              >
                £
                <InputNumber
                  v-model="datesFrom[index]"
                  placeholder="From"
                  style="width: 45%;"
                />
                £
                <InputNumber
                  v-model="datesTo[index]"
                  placeholder="To"
                  style="width: 45%; float: right;"
                />
              </div>
              <div
                v-else-if="getFieldType(index) === 'Number'"
                style="width: 250px;"
              >
                <InputNumber
                  v-model="datesFrom[index]"
                  placeholder="From"
                  style="width: 49%;"
                />
                <InputNumber
                  v-model="datesTo[index]"
                  placeholder="To"
                  style="width: 49%; float: right;"
                />
              </div>
              <div
                v-else-if="getFieldType(index) === 'Yes/No'"
                style="width: 250px;"
              >
                <Dropdown
                  :showClear="true"
                  v-model="quickFiltersSelection[index]"
                  :options="getOptions(index)"
                  :optionLabel="getOptionLabel(element, index)"
                  :dataKey="getDataKey(element)"
                  placeholder="Select from the dropdown"
                  style="width: 100%"
                />
              </div>
              <div v-else style="width: 250px">
                <MultiSelect
                  filter
                  v-model="quickFiltersSelection[index]"
                  :options="getOptions(index)"
                  :optionLabel="getOptionLabel(element)[0]"
                  placeholder="Type to display options"
                  style="width: 100%"
                />
              </div>
            </div>
            <ProgressSpinner
              v-else
              style="width:30px; height:30px"
              strokeWidth="2"
              fill="#EEEEEE"
              animationDuration=".5s"
            />
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          style="float: left;"
          label="Clear All Filters"
          icon="pi pi-times"
          class="p-button-danger"
          @click="clearQuickFilter()"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-info"
          style="width: 100px;"
          @click="quickFilterDialog = false"
        />
        <Button
          label="Apply Filters"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 130px;"
          @click="setupQuickFilter()"
        />
      </template>
    </Dialog>

    <Dialog header="Header" :visible.sync="deleteSavedFilterWarning">
      <template #header>
        <h3>Delete Alert</h3>
      </template>

      Are you sure you want to delete this filter?

      <template #footer>
        <Button
          @click="deleteSavedFilterWarning = false"
          label="No"
          icon="pi pi-times"
          class="p-button-success"
          style="width: 80px;"
        />
        <ProgressSpinner
          v-if="deleteRequesting"
          style="width:25px; height:25px; width: 80px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          @click="deleteSavedFilter()"
          label="Yes"
          icon="pi pi-check"
          autofocus
          class="p-button-danger"
          style="width: 80px;"
        />
      </template>
    </Dialog>

    <ProgressSpinner
      v-if="firstRequesting"
      style="width:50px; height:50px;"
      strokeWidth="5"
      fill="#EEEEEE"
      animationDuration=".5s"
    />
    <div v-else style="width: 100%;">
      <component
        :is="tableComponent"
        :dbView="dbView"
        :colSelectedFieldsForTable="colSelectedFieldsForTable"
        :colSelectedFieldsForTable1="colSelectedFieldsForTable1"
        :data="opportunities"
        :dbViewFields="dbViewFields"
        :colSelectedFields="colSelectedFields"
        :loading="loading"
        :totalRecords="totalRecords"
        :rows="rows"
        :currentPage="currentPage"
        :reloadTable="realoadLazyTable"
        :opportunityStatuses="opportunityStatuses"
        :showExportButton="true"
        @editOpportunity="editOpportunity"
        @newQuote="newQuote"
        @deleteOpportunity="confirmDeleteOpportunity"
        @reload="reload"
        @lazyNext="lazyNext"
        @sortChange="sortChange"
        @colSaved="colSaved()"
        @colUpdated="colUpdated"
        @editActiveQuote="editActiveQuote"
        :makingExport="makingExport"
        @exportData="exportData"
      />
    </div>

    <ColumnSelection
      :columnSelectionDialog="columnSelectionDialog"
      :dbView="dbView"
      :dbViewFields="dbViewFields"
      :selectionToEdit="colSelectedFields"
      :reloadComponent="reloadColumnSelectionComponent"
      :resettingColumns="resettingColumns"
      @close="columnSelectionDialog = false"
      @colSaved="colSaved()"
      @resetCols="resetCols"
    />

    <FilterForm
      v-if="filterFormDialog"
      :filterForm="filterFormDialog"
      :getDBViewFieldsId="dbView"
      :filterToEdit="filterToEdit"
      @close="filterFormDialog = false"
      @saved="filterSaved()"
    />

    <!-- EnquiryForm -->
    <component
      :is="enquiryFormComponent"
      :key="formKey"
      v-if="opportunityDialog"
      :onlyUserBranch="onlyUserBranch"
      :opportunityDialog="opportunityDialog"
      :opportunityToEdit="opportunityToEdit"
      :disabledArray="disabledArr"
      :colSelectedFieldsForTable="colSelectedFieldsForTable"
      @close="opportunityDialog = false"
      @saving="enquirySaveStarted"
      @save-failed="enquirySaveFailed"
      @save="savedOpportunity"
    />

    <!-- QuotationForm -->
    <component
      :is="quoteFormComponent"
      :key="quoteFormKey"
      :quotationDialog="quotationDialog"
      :opportunity="opportunityForQuotation"
      :quoteToEdit="quoteToEdit"
      :active="activeQuote"
      :disabledArr="disabledArr"
      @close="closeQuotationForm"
      @saved="quoteSaved"
    />

    <duplicateTable
      v-if="colSelectedFieldsForTable"
      :duplicateDialog="displayDuplicateMessage"
      :colSelectedFieldsForTable="colSelectedFieldsForTable"
      :dataId="'oppId'"
      :name="'Enquiry'"
      :namePlural="'Enquiries'"
      :list="duplicates"
      :requesting="duplicateRequesting"
      @close="displayDuplicateMessage = false"
      @agree="sendDuplicate"
    />

    <EnquirySaveProgress
      :visible="displaySuccess"
      :saveState="enquirySaveState"
      :emailState="enquiryEmailState"
      :quoteNo="savedSQuoteNo"
      @close="displaySuccess = false"
      @book-in="
        displaySuccess = false;
        newQuote(opportunity);
      "
    />
  </div>
</template>

<script>
import { editedFilterIsCurrent } from "@/mbp/editedFilterIsCurrent";
import { mapActions, mapGetters } from "vuex";

import OpportunityService from "@/service/OpportunityService";
import FiltersService from "@/service/FiltersSerice";
import QuotationService from "@/service/QuotationService";

import OpportunityTableForLazyLoading from "../universalComponents/opportunity/OpportunityTableForLazyLoadingWithResize";
import ColumnSelection from "../universalComponents/columnSelection/ColumnSelection";
import FilterForm from "../universalComponents/filter/filterForm";
import FilterName from "../universalComponents/general/filterName";
import OpportunityForm from "@/mbp/universalComponents/opportunity/OpportunityForm.vue";
import QuotationForm from "@/mbp/universalComponents/quotation/QuotationForm.vue";
import duplicateTable from "../universalComponents/opportunity/duplicateDialog";
import EnquirySaveProgress from "@/mbp/universalComponents/opportunity/EnquirySaveProgress.vue";
import PermissionMixin from "../PermissionMixin.vue";
import moment from "moment";

import ListViewStateMixin from "../ListViewStateMixin.vue";
import { savedFilterChanged } from "../savedFilterChanged.js";
import { quickFilterValue, hasQuickFilterSelection } from "../quickFilterValue.js";

export default {
  // Vuex module holding this list's persisted filter/sort/page/scroll state.
  listViewModule: "enquiries",
  components: {
    OpportunityTableForLazyLoading,
    ColumnSelection,
    FilterForm,
    OpportunityForm,
    QuotationForm,
    duplicateTable,
    FilterName,
    EnquirySaveProgress
  },
  mixins: [PermissionMixin, ListViewStateMixin],
  created() {
    this.setupComponent();
  },
  destroyed() {},
  data: () => ({
    opportunityService: new OpportunityService(),
    filtersService: new FiltersService(),
    quotationService: new QuotationService(),
    onlyUserBranch: false,
    dbView: 8,
    filterFormDialog: false,
    savedFilters: null,
    savedFilter: null,
    opportunities: [], // For whole data set
    opportunity: {},
    opportunityToEdit: {},
    searchText: "",
    opportunityDialog: false,
    displayDuplicateMessage: false,
    duplicateInfo: {},
    messages: [],
    dbViewFields: [],
    dbViewFieldsForQuickFilters: [],
    quickFiltersSelection: [],
    datesFrom: [],
    datesTo: [],
    quickFiltersOptions: [],
    tableKey1: 0,
    disabledArr: [],
    columnSelectionDialog: false,
    defaultView: true,
    colSelectedFields: [],
    colSelectedFieldsForTable: [],
    duplicates: [],
    requesting: false,
    tableKey1: 0,
    realoadLazyTable1: 0,
    deleteSavedFilterWarning: false,
    quickFilterDialogKey1: 0,
    quickFilterDialog: false,
    filterToEdit: {},
    opportunityStatuses: [],
    formKey1: 0,
    quoteFormKey1: 0,
    savedSQuoteNo: "",
    displaySuccess: false,
    // Line 1 of the save popup: 'pending' | 'saved' | 'error'
    enquirySaveState: "pending",
    // Line 2: 'pending' | 'SENT' | 'SKIPPED' | 'FAILED' (from the save response)
    enquiryEmailState: "pending",
    selectedCustomer: null,
    activeQuote: false,
    quoteToEdit: {},
    opportunityForQuotation: {},
    quotationDialog: false,
    quickFiltersDivKey1: 0,
    reloadColumnSelectionComponent: 0,
    resettingColumns: false,
    deleteRequesting: false,
    favoriteRequesting: false,
    favorite: false,

    colSelectedFields1: [],
    colSelectedFieldsForTable1: [], // used for quotations
    dbViewFields1: [],
    dbView1: 4,

    totalRecords: null,
    totalPages: null,
    currentPage: 1,
    rows: 25,
    sortField: "",
    sortFieldId: 0,
    sortOrder: 0,
    lastMainRequestBody: {},
    lastMainRequest: "",
    firstRequesting: true,
    forceReload: false,
    duplicateRequesting: false,

    makingExport: false
  }),
  computed: {
    myPermissions() {
      return this.$store.getters["auth/getUserPermissions"];
    },
    hardLoad() {
      return this.listViewGet("getHardLoad");
    },
    softReload() {
      return this.listViewGet("getSoftReload");
    },
    realoadLazyTable: {
      set() {
        this.tableKey1++;
      },
      get() {
        return "realoadLazyTable-" + this.tableKey1.toString();
      }
    },
    loading() {
      //
      if (this.opportunities && this.opportunities[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    },
    tableComponent() {
      return this.firstRequesting === false
        ? OpportunityTableForLazyLoading
        : null;
    },
    quickFilterDialogKey: {
      set() {
        this.quickFilterDialogKey1++;
      },
      get() {
        return "quickFilterDialogKey-" + this.quickFilterDialogKey1.toString();
      }
    },
    enquiryFormComponent() {
      return this.firstRequesting === false || this.opportunityDialog
        ? OpportunityForm
        : null;
    },
    quoteFormComponent() {
      return this.firstRequesting === false || this.quotationDialog
        ? QuotationForm
        : null;
    },
    formKey: {
      set(val) {
        this.formKey1++;
      },
      get() {
        return "formKey" + this.formKey1.toString();
      }
    },
    quoteFormKey: {
      set(val) {
        this.quoteFormKey1++;
      },
      get() {
        return "quoteFormKey" + this.quoteFormKey1.toString();
      }
    },
    quickFiltersDivKey: {
      set(val) {
        this.quickFiltersDivKey1++;
      },
      get() {
        return "quickFiltersDivKey" + this.quickFiltersDivKey1.toString();
      }
    },
    ...mapGetters("auth", [
      "getMyProfile", // -> this.getMyProfile
      "getMyToken" // -> this.getMyToken
    ])
  },
  watch: {
    quotationDialog(val) {
      //
      if (
        val &&
        this.opportunityForQuotation &&
        this.opportunityForQuotation.customer &&
        this.opportunityForQuotation.customer.requireApproval === true
      ) {
        this.quotationDialog = false;

        this.$toast.add({
          severity: "warn",
          summary: "Not allowed",
          detail: "Customer must be approved before Booking In the quotation",
          life: 5000
        });
      }
    },
    currentPage(val) {
      //
      this.listViewSet("setPage", {
        page: val,
        rows: this.listViewGet("getRows")
      });

      if (val === 1) {
        this.realoadLazyTable++;
      }
    },
    hardLoad(val) {
      //

      this.setupComponentData(1);
    },
    softReload(val) {
      //

      this.setupComponentData(0);
    },
    colSelectedFields(val) {
      this.$store.dispatch(`commons/columnsSelection${this.dbView}`, val);
      this.setupColumns();
    },
    colSelectedFields1(val) {
      this.$store.dispatch(`commons/columnsSelection${this.dbView1}`, val);
      this.setupColumns1();
    },
    colSelectedFieldsForTable(val) {
      this.realoadLazyTable++;
      // setTimeout(() => this.colSelectedFieldsForTable.forEach(a =>
    },
    savedFilter(val) {
      //

      if (val && (val.favourite !== null || val.favourite !== undefined)) {
        this.favorite = val.favourite;
      }

      let oldFilter = this.listViewGet("getMainListSavedFilter");

      this.listViewSet("setMainListSavedFilter", val);

      if (savedFilterChanged(oldFilter, val)) {
        this.currentPage = 1;
      }

      this.getDataFromSource();
    },
    dbViewFieldsForQuickFilters(val) {
      //
      if (
        !this.quickFiltersSelection.every(
          element => element === undefined || element === null
        )
      ) {
        this.getDataFromSource();
      }
    },
    dbViewFields(val) {
      this.setupViewFieldsForQuickFilters();

      //
      if (this.colSelectedFieldsForTable.length < 1) {
        this.colSelectedFieldsForTable = val.filter(a => a.defView);
      }
      // this.colSelectedFieldsForTable.forEach(a =>
    },
    quickFiltersSelection(val) {
      //
      this.listViewSet("setMainListQuickFilters", val);
    },
    datesFrom(val) {
      this.listViewSet("setQuickFiltersDatesFrom", val);
    },
    datesTo(val) {
      this.listViewSet("setQuickFiltersDatesTo", val);
    },
    dbViewFields1(val) {
      // toggles between default view and user saved view

      if (this.colSelectedFieldsForTable1.length < 1) {
        this.colSelectedFieldsForTable1 = val.filter(a => a.defView);
      }
      // this.colSelectedFieldsForTable1.forEach(a =>
    },
    opportunityDialog(val) {
      if (val) {
        this.formKey++;
      }
    }
    // opportunities(val) {
    //
    //   if (val[0] && this.opportunityStatuses[0]) {
    //     if (!val[0].colourCode) {
    //       var vals = []
    //       val.forEach(a => {
    //         let c = this.opportunityStatuses.find(b => b.id === a.oppStatusId)
    //
    //         if (c) {
    //           vals.push({
    //             ...a,
    //             colourCode: c.colourCode
    //           })
    //         } else {
    //           vals.push(a)
    //         }
    //       })
    //       this.opportunities = val
    //     }
    //   }
    // }
  },
  methods: {
    editActiveQuote(opportunity) {
      this.quoteToEdit = {};
      if (opportunity && opportunity.activeQuoteVerId) {
        this.quotationService
          .getQuotationInfo(opportunity.activeQuoteVerId)
          .then(data => {
            this.quoteToEdit = data;
            this.quotationDialog = true;
          })
          .catch(err => {
            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content:
                'Some data was not loaded from "quotationinfo/{quoteVerId}"'
            });
          });
      }
    },
    makeFavorite() {
      this.favorite = !this.favorite;

      this.favoriteRequesting = true;
      this.filtersService
        .setSavedFilterFav(this.savedFilter.id, this.favorite ? 1 : 0)
        .then(data => {
          let filterIndex = this.savedFilters.findIndex(
            filter => filter.id === this.savedFilter.id
          );
          if (filterIndex >= 0) {
            this.savedFilters[filterIndex].favourite = this.favorite;
          }
          this.favoriteRequesting = false;
        })
        .catch(error => {
          this.favoriteRequesting = false;
          this.favorite = !this.favorite;

          this.$toast.add({
            severity: "error",
            summary: "Can't change favorite...",
            detail: "Error while changing favorite status of this filter.",
            life: 5000
          });
        });
    },
    resetCols() {
      this.resettingColumns = true;

      this.filtersService
        .resetColumns(this.dbView)
        .then(data => {
          this.resettingColumns = false;
          this.columnSelectionDialog = false;
          this.colSelectedFields = data;
          this.getDBViewFields();
        })
        .catch(error => {
          this.resettingColumns = false;
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Error while reseting columns`,
            life: 5000
          });
        });
    },
    colUpdated(obj) {
      if (obj) {
        var id = obj.id,
          width = obj.width;
        //
        let a = this.colSelectedFields.findIndex(b => b.id === id);
        if (a >= 0 && this.colSelectedFields[a]) {
          this.colSelectedFields[a].width = width;
        }
      }
    },
    setupComponent() {
      this.firstRequesting = true;

      // setTimeout(() => {
      //
      //   if (!this.forceReload) {
      let a = this.listViewGet("getFirstTimeLoad");

      if (a) {
        this.listViewSet("setFirstTimeLoad", false);
        this.setupComponentData(1);
      } else {
        this.setupComponentData(0);
      }
      //   }
      // }, 50)

      this.getUserViewFilters();

      this.getColumnSelection();

      this.getDBViewFields();

      this.getDBViewFields1(); // for quotations

      this.getColumnSelection1(); // for quotations

      this.opportunityService
        .getAllActiveOpportunityStatuses()
        .then(data => {
          this.opportunityStatuses = data;
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting Enquiry statuses",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeOpportunityStatuses"'
          });
        });
    },
    setupComponentData(hardLoad) {
      if (hardLoad) {
        this.forceReload = true;

        // setup sort

        this.sortField = "";
        this.sortFieldId = 0;
        this.sortOrder = 0;
        this.listViewSet("setSort", {
          sortField: this.sortField,
          sortFieldId: this.sortFieldId,
          sortOrder: this.sortOrder
        });

        // setup page and rows

        this.rows = 25;
        this.currentPage = 1;
        this.listViewSet("setPage", {
          page: this.currentPage,
          rows: this.rows
        });

        this.realoadLazyTable++;

        // setup search

        this.searchText = "";
        this.syncSearchToUrl("");

        // A hard load is a deliberate reset, so drop the stored scroll offset
        // too - otherwise the reset list would jump back down the page.
        this.persistScrollY(0);
        this.persistGridScrollY(0);

        // setup quick filters

        this.quickFiltersSelection = [];
        this.datesFrom = [];
        this.datesTo = [];
        this.listViewSet("setMainListQuickFilters",
          this.quickFiltersSelection
        );
        this.listViewSet("setQuickFiltersDatesFrom",
          this.datesFrom
        );
        this.listViewSet("setQuickFiltersDatesTo", this.datesTo);

        // setup savedfilter

        this.getDefUserViewFilter()
          .then(savedFilter => {
            if (!savedFilter) {
              this.getDataFromSource();
            } else {
              this.savedFilter = savedFilter;
            }
          })
          .catch(err => {
            this.getDataFromSource();
          });
      } else {
        // setup sort

        if (this.listViewGet("getSortField")) {
          this.sortField = this.listViewGet("getSortField");
          this.sortFieldId = this.listViewGet("getSortFieldId");
          this.sortOrder = this.listViewGet("getSortOrder");
        }

        // setup page and rows

        this.rows = this.listViewGet("getRows");
        this.currentPage = this.listViewGet("getPage");

        // setup search

        this.searchText = this.$route.query.search || this.listViewGet("getSearchText") || "";

        // setup quick filters

        this.quickFiltersSelection = [
          ...this.listViewGet("getMainListQuickFilter")
        ];
        this.datesFrom = [
          ...this.listViewGet("getQuickFiltersDatesFrom")
        ];
        this.datesTo = [
          ...this.listViewGet("getQuickFiltersDatesTo")
        ];

        // setup savedfilter

        this.savedFilter = {
          ...this.listViewGet("getMainListSavedFilter")
        };

        // Re-entering the list, so put the user back where they were. This
        // waits for the lazy grid to render before scrolling.
        this.restoreListScroll();
      }
    },
    getDataFromSource() {
      let savedFilter1 = 0,
        quickFilters = {};

      if (this.savedFilter && this.savedFilter.id) {
        savedFilter1 = this.savedFilter.id;
      }

      var cancelRequest = false;

      //

      if (
        !(
          this.quickFiltersSelection.every(
            element => element === undefined || element === null
          ) &&
          this.datesFrom.every(
            element => element === undefined || element === null
          ) &&
          this.datesTo.every(
            element => element === undefined || element === null
          )
        )
      ) {
        if (this.dbViewFieldsForQuickFilters.length) {
          for (let i = 0; i < this.dbViewFieldsForQuickFilters.length; i++) {
            try {
              if (this.dbViewFieldsForQuickFilters[i].quickFilter) {
                //

                let a = this.dbViewFieldsForQuickFilters[i].dbField
                  .split(".")
                  .slice(0)[0];
                let b = this.dbViewFieldsForQuickFilters[i].dbField
                  .split(".")
                  .slice(-1)[0];

                // A Yes/No Dropdown holds one option object, which has no length
                if (
                  hasQuickFilterSelection(
                    this.dbViewFieldsForQuickFilters[i],
                    this.quickFiltersSelection[i]
                  )
                ) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].fieldType === "Date"
                  ) {
                    //

                    if (
                      this.quickFiltersSelection[i].dateModifierFunc ===
                      "custom"
                    ) {
                      //
                      if (this.datesFrom[i]) {
                        try {
                          quickFilters[`${a}From`] = moment(
                            this.datesFrom[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}From`] = this.datesFrom[i];
                        }
                      }
                      if (this.datesTo[i]) {
                        try {
                          quickFilters[`${a}To`] = moment(
                            this.datesTo[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}To`] = this.datesTo[i];
                        }
                      }
                    } else {
                      quickFilters[a] = this.quickFiltersSelection[
                        i
                      ].dateModifierFunc;
                    }
                  } else {
                    // Yes/No, "*" lists and id lists; a multi-select "*" list sends a
                    // comma list and Yes/No sends true/false (see quickFilterValue.js)
                    const value = quickFilterValue(
                      this.dbViewFieldsForQuickFilters[i],
                      this.quickFiltersSelection[i]
                    );
                    if (value !== undefined) quickFilters[a] = value;
                  }
                } else if (this.datesFrom[i] || this.datesTo[i]) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].fieldType ===
                      "Currency" ||
                    this.dbViewFieldsForQuickFilters[i].fieldType === "Number"
                  ) {
                    //
                    quickFilters[`${a}From`] = this.datesFrom[i];
                    quickFilters[`${a}To`] = this.datesTo[i];
                  }
                }
              }
            } catch (e) {
              continue;
            }
          }
        } else {
          cancelRequest = true;
        }
      }
      //
      var thisMainRequestBody = JSON.stringify(quickFilters);

      let searchQuery = "*";
      if (this.searchText) {
        searchQuery = this.searchText;
      }

      var thisRequest = `${savedFilter1}/${this.currentPage}/${this.rows}/${this.sortFieldId}/${this.sortOrder}/${searchQuery}`;

      if (!cancelRequest) {
        if (
          !(
            thisRequest === this.lastMainRequest &&
            thisMainRequestBody === this.lastMainRequestBody
          ) ||
          this.forceReload
        ) {
          this.forceReload = false;

          this.lastMainRequest = thisRequest;
          this.lastMainRequestBody = thisMainRequestBody;

          this.requesting = true;
          this.opportunities = [];

          quickFilters.searchText = searchQuery;

          this.opportunityService
            .getEnquiries(
              savedFilter1,
              this.currentPage,
              this.rows,
              this.sortFieldId,
              this.sortOrder,
              "*",
              quickFilters
            )
            .then(response => {
              //

              let responseData = JSON.parse(response.config.data),
                a = response.config.url.split("/");

              a[8] = responseData.searchText;

              let b = a.map(c => parseInt(c));

              delete responseData.searchText;
              responseData = JSON.stringify(responseData);

              if (
                a[8] === "*" &&
                this.searchText === "" &&
                b[3] === savedFilter1 &&
                b[4] === this.currentPage &&
                b[5] === this.rows &&
                b[6] === this.sortFieldId &&
                b[7] === this.sortOrder &&
                responseData &&
                responseData === this.lastMainRequestBody
              ) {
                this.requesting = false;
                this.firstRequesting = false;

                this.totalRecords = parseInt(response.headers.reccount);
                this.opportunities = response.data;
              } else if (
                b[3] === savedFilter1 &&
                b[4] === this.currentPage &&
                b[5] === this.rows &&
                b[6] === this.sortFieldId &&
                b[7] === this.sortOrder &&
                a[8] === this.searchText &&
                responseData &&
                responseData === this.lastMainRequestBody
              ) {
                this.requesting = false;
                this.firstRequesting = false;

                this.totalRecords = parseInt(response.headers.reccount);
                this.opportunities = response.data;
              }
            })
            .catch(err => {
              this.requesting = false;

              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: `Error while getting enquiries for saved filter ${savedFilter1} and search text ${this.searchText}`,
                life: 5000
              });
            });
        }
      }
    },
    sortChange({ sortField, sortFieldId, sortOrder }) {
      this.listViewSet("setSort", {
        sortField,
        sortFieldId,
        sortOrder
      });

      this.sortField = sortField;
      this.sortFieldId = sortFieldId;
      this.sortOrder = sortOrder;

      if (this.currentPage !== 1) {
        this.currentPage = 1;
      }

      this.getDataFromSource();
    },
    lazyNext({ page, rows, totalPages }) {
      this.listViewSet("setPage", { page, rows });

      this.rows = rows;
      this.totalPages = totalPages;
      if (this.currentPage !== page) {
        this.currentPage = page;
      }

      this.getDataFromSource();
    },
    setupQuickFilter() {
      this.quickFilterDialog = false;
      //
      this.listViewSet("setMainListQuickFilters",
        this.quickFiltersSelection
      );
      this.listViewSet("setQuickFiltersDatesFrom",
        this.datesFrom
      );
      this.listViewSet("setQuickFiltersDatesTo", this.datesTo);

      this.getDataFromSource();
    },
    closeSearch() {
      this.searchText = "";
      this.syncSearchToUrl("");

      this.getDataFromSource();
    },
    updateSearch(e) {
      this.searchText = e;
      this.syncSearchToUrl(e);

      this.getDataFromSource();
    },
    checkExistanceOfFilterFldId(quickFilterOptionsList, index) {
      try {
        // this.quickFiltersSelection[index] = quickFilterOptionsList.find(a => a[this.dbViewFields[index].dbIdField] ===  this.dbViewFields[index].filterDefId)
      } catch (e) {}
    },
    setupViewFieldsForQuickFilters() {
      var duplicateDate = [];

      this.dbViewFields.forEach(d => {
        // if (d.fieldName === "Start Date") {
        //   duplicateDate.push({...d, dbField: "startDateFrom", fieldName: "Start Date From"})
        //   duplicateDate.push({...d, id: d.id + '1', dbField: "startDateTo", fieldName: "Start Date To"})

        // } else {
        duplicateDate.push(d);
        // }
      });

      this.dbViewFieldsForQuickFilters = [];

      var notExists = this.quickFiltersSelection.every(
        element => element === undefined || element === null
      );

      //

      duplicateDate.forEach((d, index) => {
        this.dbViewFieldsForQuickFilters.push(d);

        //

        if (d.quickFilter) {
          if (d.fieldType === "Date") {
            this.filtersService
              .getDateModifiers()
              .then(data => {
                this.quickFiltersOptions[index] = data;
                this.checkExistanceOfFilterFldId(
                  this.quickFiltersOptions[index],
                  index
                );
              })
              .catch(err => {
                // this.$toast.add({
                //   severity: "error",
                //   summary: "Error",
                //   detail: "Error while getting date modifiers",
                //   life: 5000,
                // })
                this.$store.dispatch("addErrorMessage", {
                  severity: "error",
                  content: 'Some data was not loaded from "dateModifiers"'
                });
              });
          } else if (d.lovEP) {
            //
            if (d.lovEP === "YES/NO") {
              this.quickFiltersOptions[index] = [
                { id: 1, [d.dbField]: "Yes" },
                { id: 2, [d.dbField]: "No" }
              ];
              this.checkExistanceOfFilterFldId(
                this.quickFiltersOptions[index],
                index
              );
            } else if (d.lovEP.substr(0, 1) === "*") {
              let list = d.lovEP.substr(1).split("/");
              if (list.length) {
                this.quickFiltersOptions[index] = list.map((a, index) => {
                  return { id: index, [d.dbField]: a };
                });
                this.checkExistanceOfFilterFldId(
                  this.quickFiltersOptions[index],
                  index
                );
              }
            } else {
              this.filtersService
                .filtersCustomRequest(d.lovEP)
                .then(data => {
                  this.quickFiltersOptions[index] = data;
                  this.checkExistanceOfFilterFldId(
                    this.quickFiltersOptions[index],
                    index
                  );
                })
                .catch(err => {
                  if (err && err.response && err.response.status !== 200) {
                    // this.$toast.add({
                    //   severity: "error",
                    //   summary: "Error",
                    //   detail: "Error while getting quick filters",
                    //   life: 5000,
                    // })
                    this.$store.dispatch("addErrorMessage", {
                      severity: "error",
                      content: `Some data was not loaded from "${d.lovEP}"`
                    });
                  }
                });
            }
          }
        }
        if (notExists) {
          this.quickFiltersSelection.push(null);
        }
        this.quickFiltersOptions.push({});
        //
      });

      //
      //
    },
    getDefUserViewFilter() {
      return new Promise(async (resolve, reject) => {
        this.filtersService
          .getDefUserViewFilter(this.dbView)
          .then(data => resolve(data))
          .catch(err => {
            this.savedFilter = {};

            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting default user view filter.",
            //   life: 5000,
            // })
            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content:
                'Some data was not loaded from "defUserViewFilter/{dbView}"'
            });
            reject();
          });
      });
    },
    getUserViewFiltersByHard() {
      this.filtersService
        .getUserViewFiltersByHard(this.dbView)
        .then(data => {
          //
          let obj = { ...this.savedFilter };

          this.savedFilters = data;
          if (obj && obj.id) {
            this.savedFilter = data.find(a => {
              if (a && a.id === obj.id) {
                return true;
              }
            });
          }
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer user filters",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "userViewFilters/{dbView}"'
          });
        });
    },
    getUserViewFilters() {
      this.filtersService
        .getUserViewFilters(this.dbView)
        .then(data => {
          //
          this.savedFilters = data;
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer user filters",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "userViewFilters/{dbView}"'
          });
        });
    },
    setupColumns() {
      if (
        this.colSelectedFields &&
        this.colSelectedFields[0] &&
        this.columnSelectionDialog
      ) {
        this.reloadColumnSelectionComponent++;
      }

      let a = [];
      this.colSelectedFields.forEach(b => {
        //
        let c = a.find(d => d.dbField === b.dbField.dbField);
        //
        if (!a[b.colOrder - 1] && !c) {
          a[b.colOrder - 1] = {
            ...b.dbField,
            defWidth: b.width
          };
        }
      });

      if (a.length) {
        this.colSelectedFieldsForTable = a;
      }
    },
    getColumnSelectionByHard() {
      this.filtersService
        .getColumnSelectionByHard(this.dbView)
        .then(data => {
          this.colSelectedFields = data;
        })
        .catch(err => {
          if (err.response.status === 500) {
            // Default view

            this.defaultView = true;
          }

          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "currentUserViewFields/{dbView}"'
          });
        });
    },
    getColumnSelection() {
      this.filtersService
        .getColumnSelection(this.dbView)
        .then(data => {
          this.colSelectedFields = data;
        })
        .catch(err => {
          if (err.response.status === 500) {
            // Default view

            this.defaultView = true;
          }

          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "currentUserViewFields/{dbView}"'
          });
        });
    },
    setupColumns1() {
      let a = [];
      this.colSelectedFields1.forEach(b => {
        //
        let c = a.find(d => d.dbField === b.dbField.dbField);
        //
        if (!a[b.colOrder - 1] && !c) {
          a[b.colOrder - 1] = {
            ...b.dbField,
            defWidth: b.width
          };
        }
      });

      if (a.length) {
        this.colSelectedFieldsForTable1 = a;
      }
    },
    getColumnSelectionByHard1() {
      this.filtersService
        .getColumnSelectionByHard(this.dbView1)
        .then(data => {
          this.colSelectedFields1 = data;
        })
        .catch(err => {
          if (err.response.status === 500) {
            // Default view

            this.defaultView = true;
          }

          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "currentUserViewFields/{dbView}"'
          });
        });
    },
    getColumnSelection1() {
      this.filtersService
        .getColumnSelection(this.dbView1)
        .then(data => {
          this.colSelectedFields1 = data;
        })
        .catch(err => {
          if (err.response.status === 500) {
            // Default view

            this.defaultView = true;
          }

          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "currentUserViewFields/{dbView}"'
          });
        });
    },
    getDBViewFields1() {
      this.filtersService
        .getDBViewFields(this.dbView1)
        .then(data => {
          this.dbViewFields1 = [];

          data.forEach((d, index) => {
            //
            this.dbViewFields1.push(d);
          });
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting quotations DB view fields",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "dbViewFields/{dbView}"'
          });
        });
    },
    getDBViewFields() {
      this.filtersService
        .getDBViewFields(this.dbView)
        .then(data => (this.dbViewFields = data))
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer DB view fields",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "dbViewFields/{dbView}"'
          });
        });
    },
    isEmpty() {
      //
      return !(
        this.quickFiltersSelection.every(
          element => element === undefined || element === null
        ) &&
        this.datesFrom.every(
          element => element === undefined || element === null
        ) &&
        this.datesTo.every(element => element === undefined || element === null)
      );
    },
    getBadgeForQuickFilters() {
      //
      let count = 0;
      for (let i = 0; i < this.quickFiltersSelection.length; i++) {
        if (
          this.quickFiltersSelection[i] ||
          this.datesFrom[i] ||
          this.datesTo[i] ||
          this.datesFrom[i] === 0 ||
          this.datesTo[i] === 0
        ) {
          if (Array.isArray(this.quickFiltersSelection[i])) {
            if (this.quickFiltersSelection[i].length > 0) count++;
          } else {
            count++;
          }
        }
      }
      //
      return count;
    },
    getClassForQuickFiltersButon() {
      if (this.isEmpty()) {
        return "p-button-success";
      } else {
        return "p-button-info";
      }
    },
    getClassForQuickFiltersDiv() {
      if (this.isEmpty()) {
        return "greenBackground";
      } else {
        return "defaultBackground";
      }
    },
    isQuickFilterable(index) {
      //
      return this.dbViewFieldsForQuickFilters[index] &&
        this.dbViewFieldsForQuickFilters[index].quickFilter
        ? this.dbViewFieldsForQuickFilters[index].quickFilter
        : false;
    },
    dontShowSpinner(index) {
      if (
        this.dbViewFieldsForQuickFilters[index] &&
        this.dbViewFieldsForQuickFilters[index].lovEP &&
        this.quickFiltersOptions[index] &&
        !this.quickFiltersOptions[index][0]
      ) {
        return false;
      } else {
        return true;
      }
    },
    getFieldType(index) {
      //
      //
      //
      return this.dbViewFieldsForQuickFilters[index] &&
        this.dbViewFieldsForQuickFilters[index].fieldType
        ? this.dbViewFieldsForQuickFilters[index].fieldType
        : "";
    },
    setSelection({ value, index }) {
      this.quickFiltersSelection[index] = value;
    },
    useAutoComplete(index) {
      //
      return this.dbViewFieldsForQuickFilters[index]
        ? this.dbViewFieldsForQuickFilters[index].filterAutocomplete
        : false;
    },
    showDropdown(index) {
      return this.dbViewFieldsForQuickFilters[index]
        ? this.dbViewFieldsForQuickFilters[index].filterDropdown
        : false;
    },
    isForceSelection(index) {
      return this.dbViewFieldsForQuickFilters[index]
        ? !this.dbViewFieldsForQuickFilters[index].filterAllowStartWith
        : false;
    },
    getOptions(index) {
      var branchIndex = 1;
      var branch = this.$store.getters["auth/getMyProfile"].defBranch;

      if (branchIndex == index) {
        let permission = this.myPermissions.find(
          a => a.permission.permissionCode === "ViewQuotations"
        );

        if (permission) {
          if (permission.permissionLevel == 5) {
            if (!branch) {
              this.noBranchHandle();
              return;
            }
            if (this.quickFiltersOptions[index].length > 0)
              this.quickFiltersOptions[index] = this.quickFiltersOptions[
                index
              ].filter(qf => qf.id === branch.id);
            this.quickFiltersSelection[index] = [branch];
            return this.quickFiltersOptions[index];
          }
        }
      }
      return Array.isArray(this.quickFiltersOptions[index])
        ? this.quickFiltersOptions[index]
        : [];
    },
    noBranchHandle() {
      this.$router.push({ name: "dashboard", query: { toast: "yes" } });
    },
    getDataKey(data) {
      return data ? data.dbIdField : null;
    },
    getOptionLabel(data) {
      if (data) {
        if (data.dbNameField) {
          return [data.dbNameField];
        } else {
          return data ? data.dbField.split(".").slice(-1) : [];
        }
      }
    },
    showDateRanges(index) {
      //
      if (
        this.quickFiltersSelection[index] &&
        this.quickFiltersSelection[index].dateModifierFunc === "custom"
      ) {
        return true;
      } else {
        return false;
      }
    },
    clearQuickFiltersSelections() {
      for (let i = 0; i < this.quickFiltersSelection.length; i++) {
        this.quickFiltersSelection[i] = null;
        this.datesFrom[i] = null;
        this.datesTo[i] = null;
      }
      this.quickFiltersDivKey++;
    },
    clearQuickFilter() {
      this.quickFilterDialog = false;
      this.clearQuickFiltersSelections();

      this.getDataFromSource();
    },
    editSelectedFilter() {
      this.filterToEdit = { ...this.savedFilter };
      this.filterFormDialog = true;
    },
    newFilter() {
      this.filterToEdit = {};
      this.filterFormDialog = true;
    },
    reload() {
      this.forceReload = true;
      this.setupComponentData(0);
    },
    updateDefaultFilter() {
      this.filtersService
        .getDefUserViewFilterByHard(this.dbView)
        .then(data => {})
        .catch(error => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while updating default filter.",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "defUserViewFilter/{dbView}"'
          });
        });
    },
    filterSaved() {
      this.filterFormDialog = false;
      this.getUserViewFiltersByHard();
      this.updateDefaultFilter();

      // UI1d: an edit of the filter in use reloads the list (it kept the old rows)
      const editedCurrent = editedFilterIsCurrent(this.filterToEdit, this.savedFilter);
      this.filterToEdit = {};
      if (editedCurrent) this.reload();
    },
    colSaved() {
      this.columnSelectionDialog = false;

      this.getColumnSelectionByHard();
      this.getDBViewFields();
    },
    openColumnsSelection() {
      this.columnSelectionDialog = true;
      this.reloadColumnSelectionComponent++;
    },
    confirmDeleteOpportunity(data) {
      let permission = this.myPermissions.find(
        a => a.permission.permissionCode === "DeleteEnquiry"
      );
      if (permission) {
        if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to delete an enquiry",
            life: 5000
          });
        } else if (permission.permissionLevel === 1) {
          if (data && data.oppId) {
            this.opportunityService
              .deleteOpportunity(data.oppId)
              .then(() => {
                this.reload();
              })
              .catch(error => {
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: `The Enquiry was not deleted. Please ensure that there are no related records such as Quotations, Tasks, Events or Notes associated with the Opportunity. You can set the enquiry to cancelled instead.`,
                  life: 5000
                });
              });
          }
        }
      }
    },
    editOpportunity(opportunity) {
      if (
        opportunity &&
        !(
          opportunity.oppStatusName === "Cancelled" ||
          opportunity.oppStatusName === "Won" ||
          opportunity.oppStatusName === "Lost" ||
          opportunity.oppStatusName === "Expired"
        )
      ) {
        this.disabledArr = [
          // "Description",
          // "Address 1",
          // "Address 2",
          // "Address 3",
          // "City/Town",
          // "Post Code",
          "Country"
          // "Customer",
        ];

        if (opportunity.oppStatusName === "Active") {
          this.disabledArr.push("Customer");
          this.disabledArr.push("mbpBranch");
        }

        this.opportunityToEdit = this.opportunities.find(
          o => o.oppId === opportunity.oppId
        );
        this.opportunityDialog = true;
      } else {
        if (opportunity && opportunity.oppStatusName) {
          this.$toast.add({
            severity: "warn",
            summary: "Can't edit",
            detail:
              "Sorry, you can't edit if the status is " +
              opportunity.oppStatusName,
            life: 5000
          });
        } else {
          this.$toast.add({
            severity: "warn",
            summary: "Can't edit",
            detail: "Sorry, you can't edit the enquiry",
            life: 5000
          });
        }
      }
    },
    openNew() {
      let permission = this.myPermissions.find(
        a => a.permission.permissionCode === "AddNewEnquiry"
      );
      if (permission) {
        if (permission.permissionLevel === 0) {
          this.onlyUserBranch = false;
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to create a new record",
            life: 5000
          });
        } else if (
          permission.permissionLevel === 1 ||
          permission.permissionLevel === 4
        ) {
          this.onlyUserBranch = false;
          this.opportunityToEdit = { country: "UK" };
          this.opportunity = {};
          this.disabledArr = ["Country"];
          this.opportunityDialog = true;
        } else if (permission.permissionLevel === 5) {
          this.onlyUserBranch = true;
          this.opportunityToEdit = { country: "UK" };
          this.opportunity = {};
          this.disabledArr = ["Country"];
          this.opportunityDialog = true;
        }
      }
    },
    newQuote(opportunity) {
      // B-S10: a New Version must not carry the version last opened by Edit (its quoteVerId made
      // the save a PUT over that version)
      this.quoteToEdit = {};
      let permission = this.myPermissions.find(
        a => a.permission.permissionCode === "AddNewQuotation"
      );
      if (permission) {
        if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to create a new Quotation",
            life: 5000
          });
        } else if (
          permission.permissionLevel === 1 ||
          permission.permissionLevel === 4 ||
          permission.permissionLevel === 5
        ) {
          this.opportunityForQuotation = opportunity;
          this.disabledArr = ["opportunity", "mbpBranch", "Customer"];

          this.activeQuote = true;
          this.quotationDialog = true;
        }
      }
    },
    /** A create has started — open the popup with both lines pending. */
    enquirySaveStarted() {
      this.savedSQuoteNo = "";
      this.enquirySaveState = "pending";
      this.enquiryEmailState = "pending";
      this.displaySuccess = true;
    },
    /** The enquiry genuinely did not save (not a duplicate prompt). */
    enquirySaveFailed() {
      this.enquirySaveState = "error";
      this.enquiryEmailState = "pending";
    },
    savedOpportunity(e) {
      this.opportunity = e.opportunity;
      this.selectedCustomer = e.customer;
      if (e.duplicates && e.duplicates.length) {
        // Not saved yet — the user is being asked to confirm a possible duplicate.
        this.displaySuccess = false;
        this.duplicates = e.duplicates;
        this.displayDuplicateMessage = true;
      } else {
        if (e.sQuoteNo) {
          this.savedSQuoteNo = e.sQuoteNo;
          // The enquiry is committed by the time the response arrives. Whatever the
          // email did, line 1 is green from here on.
          this.enquirySaveState = "saved";
          this.enquiryEmailState = e.emailStatus || "SKIPPED";
          this.displaySuccess = true;
        } else {
          this.displaySuccess = false;
        }
      }
      this.reload();
    },
    sendDuplicate() {
      this.duplicateRequesting = true;

      this.opportunity.custCode = this.selectedCustomer.custCode;

      this.enquirySaveStarted();

      this.opportunityService
        .saveDuplicateOpportunity(this.opportunity)
        .then(response => {
          this.duplicateRequesting = false;
          this.displayDuplicateMessage = false;

          this.opportunity = response.data;

          this.savedSQuoteNo = this.opportunity.sQuoteNo;
          this.enquirySaveState = "saved";
          this.enquiryEmailState = this.opportunity.emailStatus || "SKIPPED";
          this.displaySuccess = true;

          if (response.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "New Enquiry Saved",
              detail: `new Enquiry was saved successfully, Quote No generated : ${this.opportunity.sQuoteNo}`,
              life: 5000
            });
            this.opportunityDialog = false;
            this.reload();
          }
        })
        .catch(e => {
          this.duplicateRequesting = false;
          this.displayDuplicateMessage = false;
          this.enquirySaveFailed();

          if (e.response)
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving enquiry",
              life: 5000
            });
        });
    },
    quoteSaved({ quote, file, params, active }) {
      this.activeQuote = false;
      this.quotationDialog = false;
      this.quoteToEdit = {};
      this.reload();
    },
    closeQuotationForm() {
      this.activeQuote = false;
      this.quotationDialog = false;
      this.quoteToEdit = {};
      this.quoteFormKey++;
    },
    deleteSavedFilter() {
      if (this.savedFilter && this.savedFilter.id) {
        this.deleteRequesting = true;

        this.filtersService
          .deleteFilter(this.savedFilter.id)
          .then(data => {
            this.deleteRequesting = false;
            this.deleteSavedFilterWarning = false;
            this.getUserViewFiltersByHard();
          })
          .catch(error => {
            this.deleteRequesting = false;
            this.$toast.add({
              severity: "error",
              summary: "Unable to delete.",
              detail: "Got some error while deleting this filter.",
              life: 5000
            });
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "A filter is required",
          detail: "Please select a saved filter first.",
          life: 5000
        });
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          let a = v,
            parts = j.split(".");
          parts.forEach(part => {
            if (a) {
              a = a[part];
            }
          });
          if (a === true) {
            return "Yes";
          } else if (a === false) {
            return "No";
          } else {
            return a;
          }
        })
      );
    },
    exportData() {
      let savedFilter1 = 0,
        quickFilters = {};

      if (this.savedFilter && this.savedFilter.id) {
        savedFilter1 = this.savedFilter.id;
      }

      if (
        !(
          this.quickFiltersSelection.every(
            element => element === undefined || element === null
          ) &&
          this.datesFrom.every(
            element => element === undefined || element === null
          ) &&
          this.datesTo.every(
            element => element === undefined || element === null
          )
        )
      ) {
        if (this.dbViewFieldsForQuickFilters.length) {
          for (let i = 0; i < this.dbViewFieldsForQuickFilters.length; i++) {
            try {
              if (this.dbViewFieldsForQuickFilters[i].quickFilter) {
                //

                let a = this.dbViewFieldsForQuickFilters[i].dbField
                  .split(".")
                  .slice(0)[0];
                let b = this.dbViewFieldsForQuickFilters[i].dbField
                  .split(".")
                  .slice(-1)[0];

                if (this.quickFiltersSelection[i]) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].fieldType === "Date"
                  ) {
                    //

                    if (
                      this.quickFiltersSelection[i].dateModifierFunc ===
                      "custom"
                    ) {
                      //
                      if (this.datesFrom[i]) {
                        try {
                          quickFilters[`${a}From`] = moment(
                            this.datesFrom[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}From`] = this.datesFrom[i];
                        }
                      }
                      if (this.datesTo[i]) {
                        try {
                          quickFilters[`${a}To`] = moment(
                            this.datesTo[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}To`] = this.datesTo[i];
                        }
                      }
                    } else {
                      quickFilters[a] = this.quickFiltersSelection[
                        i
                      ].dateModifierFunc;
                    }
                  } else {
                    // Yes/No, "*" lists and id lists; a multi-select "*" list sends a
                    // comma list and Yes/No sends true/false (see quickFilterValue.js)
                    const value = quickFilterValue(
                      this.dbViewFieldsForQuickFilters[i],
                      this.quickFiltersSelection[i]
                    );
                    if (value !== undefined) quickFilters[a] = value;
                  }
                } else if (this.datesFrom[i] || this.datesTo[i]) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].fieldType ===
                      "Currency" ||
                    this.dbViewFieldsForQuickFilters[i].fieldType === "Number"
                  ) {
                    //
                    quickFilters[`${a}From`] = this.datesFrom[i];
                    quickFilters[`${a}To`] = this.datesTo[i];
                  }
                }
              }
            } catch (e) {
              continue;
            }
          }
        } else {
          cancelRequest = true;
        }
      }

      let searchQuery = "*";
      if (this.searchText) {
        searchQuery = this.searchText;
      }

      quickFilters.searchText = searchQuery;

      this.checkPermissions();
      if (savedFilter1 || Object.keys(quickFilters).length > 1) {
        if (this.exportFilterToExcel === false) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You don't have permission to export this data",
            life: 5000
          });
          return;
        }
      } else if (this.exportAllToExcel === false) {
        this.$toast.add({
          severity: "error",
          summary: "Not allowed",
          detail: "You don't have permission to export this data",
          life: 5000
        });
        return;
      }
      import("@/service/Export2Excel").then(excel => {
        this.makingExport = true;
        this.opportunityService
          .getEnquiries(savedFilter1, 1, 100000, 0, 0, "*", quickFilters)
          .then(response => {
            //

            if (response.data) {
              const tHeader = [
                "Id",
                "Description",
                "Customer Name",
                "Contact Name",
                "Branch Code",
                "sQuote No.",
                "Enquiry Type",
                "Project Type",
                "Quote Quantity",
                "Product Type",
                "Product Value",
                "Project Type",
                "Status",
                "Status Comment",
                "Quote Grade",
                "Quote Project Type",
                "Sales Exec. Name",
                "City/Town",
                "Post Code",
                "Region Name",
                "Phone Number",
                "TAS Code",
                "Date Created",
                "Date Received",
                "Created By",
                "Updated By"
              ];
              const filterVal = [
                "oppId",
                "oppDescription",
                "custName",
                "contactName",
                "mbpBranchCode",
                "sQuoteNo",
                "oppTypeName",
                "projTypeName",
                "quoteQty",
                "prodTypeName",
                "productValue",
                "projTypeName",
                "oppStatusName",
                "statusComment",
                "quoteGrade",
                "quoteProdTypeName",
                "salesExecName",
                "address4",
                "postCode",
                "regionName",
                "phoneNo",
                "tasCode",
                "dateCreated",
                "dateReceived",
                "createdBy",
                "updatedBy"
              ];
              const data = this.formatJson(filterVal, response.data);
              //
              let a = new Date(),
                date =
                  a.getDate() +
                  "_" +
                  a.getMonth() +
                  1 +
                  "_" +
                  a.getFullYear() +
                  "-" +
                  a.getHours() +
                  "_" +
                  a.getMinutes() +
                  "_" +
                  a.getSeconds();

              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: "Enquiries" + "-" + date,
                autoWidth: true,
                bookType: "xlsx"
              });
            }

            this.makingExport = false;
          })
          .catch(err => {
            this.makingExport = false;

            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: `Error while getting enquiries for exporting(0/1/100000/0/0/*)`,
              life: 5000
            });
          });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.greenBackground {
  background-color: #5c9434;
  width: 83px;
}

.defaultBackground {
  // background-color: #2494f4;
  background-color: #248cc4;
  width: 50px;
}
</style>
